import { BrowserViewFrameHeader } from "@afar-research/contracts";
import * as Option from "effect/Option";
import * as Schema from "effect/Schema";

const HeaderJson = Schema.fromJsonString(BrowserViewFrameHeader);
const encodeHeader = Schema.encodeSync(HeaderJson);
const decodeHeader = Schema.decodeUnknownOption(HeaderJson);

/**
 * One frame on the Collaborative Browser's view socket: a big-endian 32-bit
 * header length, the JSON header, then the JPEG bytes. One binary message per
 * frame, so a slow client can drop whole frames and never half of one.
 */
export function encodeBrowserViewFrame(
  header: BrowserViewFrameHeader,
  jpeg: Uint8Array,
): Uint8Array {
  const headerBytes = new TextEncoder().encode(encodeHeader(header));
  const message = new Uint8Array(4 + headerBytes.length + jpeg.length);
  new DataView(message.buffer).setUint32(0, headerBytes.length, false);
  message.set(headerBytes, 4);
  message.set(jpeg, 4 + headerBytes.length);
  return message;
}

export function decodeBrowserViewFrame(
  message: ArrayBuffer | Uint8Array,
): { readonly header: BrowserViewFrameHeader; readonly jpeg: Uint8Array } | null {
  const bytes = message instanceof Uint8Array ? message : new Uint8Array(message);
  if (bytes.length < 4) return null;
  const headerLength = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getUint32(
    0,
    false,
  );
  if (4 + headerLength > bytes.length) return null;
  const header = decodeHeader(new TextDecoder().decode(bytes.subarray(4, 4 + headerLength)));
  return Option.isNone(header)
    ? null
    : { header: header.value, jpeg: bytes.subarray(4 + headerLength) };
}
